import React, {useContext} from 'react';
import Head from 'next/head';

import {SitemapContext} from '~/src/components/context/SitemapContext';
import {getStructuredCategoryBreadcrumbs} from '~/src/utilities/helpers/structuredData';

const StructuredBreadcrumbsCategory = ({categoryId}) => {
    const {all} = useContext(SitemapContext);

    const structuredData = getStructuredCategoryBreadcrumbs(categoryId, all);
    const html = JSON.stringify(structuredData);

    return (
        <Head>
            <script key="breadcrumbsStructuredData" type="application/ld+json" dangerouslySetInnerHTML={{__html: html}}></script>
        </Head>
    );
};

export default StructuredBreadcrumbsCategory;
